<template>
    <div class="pay-type-box">
        <div class="pay-type">
            <Breadcrumb :crumb="crumb" bgcolor="#fff"></Breadcrumb>
            <div class="paytype">
                <CheckboxGroup v-model="select_order_ids">
                <table class="u-table">
                    <thead>
                    <tr>
                        <th colspan="6" style="text-align: left">
                            <Checkbox :indeterminate="indeterminate"
                                      :value="checkAll"
                                      size="large"
                                      @click.prevent.native="handleCheckAll">全选</Checkbox>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="order in order_list">
                        <td style="width: 40px; border-right: 0; ">
                            <Checkbox :label="order.order_id" size="large"><span style="display: none"></span></Checkbox>
                        </td>
                        <td style="width: 100px; border-right: 0; border-left: 0; padding-left: 0; padding-right: 0">
                            <template v-if="order.order_type == 5">
                                <Avatar :src="order.designMtm.design_data.effect_picture" v-if="order.designMtm && order.designMtm.design_data" style="width: 100px; height: 100px; border-radius: 0"/>
                            </template>
                        </td>
                        <td style="width: 350px; border-left: 0; ">
                            <template v-if="order.order_type == 5">
                                {{order.designMtm.design_data.category.category_name_cn}}
                            </template>
                        </td>
                        <td class="prop" style="width: 340px">
                            <template v-if="order.order_type == 5 && order.designMtm.mtm_type!=6">
                                <div>面料颜色:{{order.designMtm.design_data.fabric_list.color.color_name_cn}}</div>
                                <div>面料材质:{{order.designMtm.design_data.fabric_list.material.fabric_name_cn}}</div>
                                <div>数量:{{order.designMtm.quantity}}</div>
                                <div>单价:{{order.designMtm.price}}</div>
                            </template>
                        </td>
                        <td class="prop" style="width: 150px; text-align: center">
                            <div class="price">￥{{order.total}}</div>
                            <div class="price-sub" v-for="total in order.totals" v-if="total.code == 'freight'">(含运费:￥{{total.total}})</div>
                        </td>
                        <td style="text-align: center">
                            <div class="status">{{order.status_name|orderStatusName}}</div>
                            <div><a @click="toDetail(order.order_id)">订单详情</a></div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </CheckboxGroup>
            </div>
			<div class="coupon-box">
				<div class="header">使用优惠券（{{ couponList.length}}张）</div>
				<div class="coupon-list">
					<div class="items" v-for="(item, index) in couponList" :key="index"
						@click="chooseCoupon(item)" >
						<img :src="getSelectCouponImg(item.id)"  class="icon" style="width: 17px;height: 17px;" />
						<div class="coupon-bg">
							<img :src="getCouponImg(item.min_order_money)" class="img"></img>
							<div class="text-white text-bold money">{{ item.reward_money }} 元</div>
							<div class="text-white  desc">{{ total > item.min_order_money ? '本单可用' : '满'+item.min_order_money+'元可用'}}</div>
						</div>
					</div>
					<div style="clear: both;"></div>
				</div>
			</div>
            <div class="paytype">
                <div class="title">选择付款方式</div>
                <div class="order-no-box">
                    <span class="order-no"></span>
                    <span class="pay-price">
						实付: <span class="red">￥{{Number(payTotal).toFixed(2)}}</span>
					</span>
                </div>

                <div class="type-box">
                    <div class="header">支付方式</div>
                    <div class="pay-box">
                        <div class="pay" v-for="(item, index) in payTypes" :key="index" @click="chooseType(item.type)">
                            <img :src="getSelectImg(item.type)" style="width: 17px;"/>
                            <img :src="item.img" style="width:auto;height: 40px;margin-left: 10px;"/>
                            <span class="credit" v-if="item.type === 'account'">余额：￥{{ account }} </span>
                        </div>
                    </div>
                </div>
                <div class="submit-box">
                    <div class="submit" @click="pay">立即付款</div>
                    <div class="pay-time" v-if="time">
                        剩余付款时间: <span class="main-color">{{ time.min }}分 {{ time.second }}秒</span>
                    </div>
                </div>

            </div>
        </div>
        <Modal
                title="支付密码"
                v-model="is_show"
                class-name="vertical-center-modal"
                width="400"
                @on-ok="ok"
        >
            <p slot="header" class="ivu-modal-header">
                <Icon type="information-circled"></Icon>
                <span>请输入支付密码</span>
            </p>
            <Input v-model="password" type="password" size="large" @on-ok="ok"/>
        </Modal>
    </div>

</template>

<script>
    import {getOrderBill, getOrderBills, accountGeneral, payOrder, getPayStatus, GetUserCopupon} from '@/api'
    import Breadcrumb from "@/components/Breadcrumb.vue";
    import util from '@/utils/util.js';

    export default {
        name: 'Paytype',
        components: {
            Breadcrumb
        },
        data() {
            return {
                indeterminate: true,
                checkAll: false,
                crumb: [{
                    title: "付款方式",
                    path: "Paytype",
                }],
                order_list: [],
                payTypes: [{
                    type: 'alipay',
                    img: require('../assets/images/pay/alipay.png')
                },
                    {
                        type: 'wechat',
                        img: require('../assets/images/pay/wechat.png')
                    },
                    {
                        type: 'account',
                        img: require('../assets/images/pay/money.png')
                    },
                ],
                pay_type: '',
                time: null,
                account: 0,
                order_id: 0,
                order_ids: "",
                password: '',
                is_show: false,
                select_order_ids: [],
				couponList:[],
				useCoupon:{
					id:0,
					coupon_id: 0,
					reward_money:0
				}
            };
        },
        computed: {
            total() {
                var total = 0;
                this.order_list.map(i => {
                   if (this.select_order_ids.indexOf(i.order_id) >= 0) {
                       total += parseFloat(i.total);
                   }
                });
                return total
            },
			payTotal() {
				if(this.total == 0) {
					return this.total
				}
				return this.total - this.useCoupon.reward_money
			},
        },
        created() {
            if(this.$route.query.id) {
                this.order_ids = this.$route.query.id
            }
            getOrderBills({order_ids: this.order_ids}).then((response) => {
                this.order_list = response.data;
                this.select_order_ids = response.data.map(i => i.order_id)
            })
            accountGeneral().then((response) => {
                this.account = response.data.money
            })
            this.setIntervalTime = setInterval(() => {
                this.timeCountDown('2021-11-21 23:59:00')
            }, 1000)
			GetUserCopupon({
				type:1,
				page:1,
				size:1000,
				member_id: this.member_id
			}).then((response)=>{
				this.couponList = response.data
			})
        },
        methods: {
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;

                if (this.checkAll) {
                    this.select_order_ids = this.order_list.map(i => i.order_id)
                } else {
                    this.select_order_ids = [];
                }
            },
            chooseType(type) {
                this.pay_type = type
            },
            pay() {
                if(this.select_order_ids.length===0) {
                    this.$Notice.error({
                        title: '请选择要付款的订单'
                    })
                    return
                }
                if (!this.pay_type) {
                    this.$Notice.error({
                        title: '请选择支付方式'
                    })
                    return
                }
                if (this.pay_type === 'account') {
                    if(!this.$store.state.userInfo.is_pay_password_set) {
                        this.$Notice.warning({
                            title: '请设置支付密码'
                        })
                        this.$router.push({name: 'PayPassword', params: {redirect: this.$route.fullPath}})
                        return
                    }
                    this.is_show = true;
                    return
                }
                payOrder({
                    order_ids: this.select_order_ids.join(','),
                    payment_type: this.pay_type,
					coupon_id: this.useCoupon.id
                }).then(response => {
                    if (this.pay_type === 'alipay') {
                        location.href = response.data.url;
                    } else if (this.pay_type === 'wechat') {
                        this.$router.push({
                            name: 'Payment',
                            params: {
                                url: response.data.url,
                                type: this.pay_type,
                                total: this.payTotal,
                                pay_id: response.data.pay_id
                            }
                        })
                    }
                }).catch((e) => {
                    this.$Notice.error({
                        title: '支付二维码获取失败'
                    })
                })
            },
			ok() {
				payOrder({
					order_ids: this.select_order_ids.join(','),
					payment_type: this.pay_type,
					password: this.password,
					coupon_id: this.useCoupon.id
				}).then(response => {
                    this.$Notice.success({
                        title: '支付成功'
                    })
                    this.$router.replace({name: 'Center'});
				}).catch((res) => {
                    this.$Notice.error({
                        title: res.msg
                    })
                })
			},
            getSelectImg(type) {
                return this.pay_type == type ? require('../assets/images/select.png') : require(
                    '../assets/images/no-select.png')
            },
			getSelectCouponImg(id) {
			    return this.useCoupon.id == id ? require('../assets/images/select.png') : require(
			        '../assets/images/no-select.png')
			},
			getCouponImg(min_order_money) {
				console.log(this.total > min_order_money ? require('../assets/images/pay/coupon.png') : require(
				    '../assets/images/pay/un_coupon.png'))
					return this.total > min_order_money ? require('../assets/images/pay/coupon.png') : require(
				    '../assets/images/pay/un_coupon.png')

			},
            timeCountDown(time) {
                // this.time = util.timeStamp(time)
                // if(this.time == 0){
                // 	this.loadGameInfo(this.id)
                // 	this.time = {}
                // 	clearInterval(this.setIntervalTime)
                // }
            },
			chooseCoupon(item) {
				if(this.total < item.min_order_money) {
					return
				}
				this.useCoupon = item
			},
			toDetail(order_id) {
				this.$router.push({
					path: "user/orderdetail",
					query: {order_id :order_id}
				});
			},
        }
    }
</script>

<style lang="scss">
    .u-table {
        width: 100%;
        border-collapse: collapse;
        thead {
            th {
                background-color: #F5F5F5;
                border: #ddd 1px solid;
                padding: 20px;
                text-align: left;
            }
        }
        tbody {
            td {
                padding: 20px;
                text-align: left;
                border: #ddd 1px solid;
                &.prop {
                    color: #666;
                    line-height: 2em;
                    font-size: 12px;
                }
                .price {
                    font-size: 15px;
                    color: #0F114A;
                }
                .price-sub {
                    color: #666;
                    font-size: 12px;
                }
                .status {
                    color: #BE0505;
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }
    }

    .pay-type-box {
        //height: 550px;
        padding-bottom: 50px;
        background: #F3F4F5;

        .pay-type {
            padding-top: 20px;
            margin: auto;
            width: 1170px;
            // padding-bottom: ;
        }

        .paytype {
            background: #FFFFFF;
            padding: 20px;
            margin-top: 20px;

            .title {
                font-size: 18px;
                color: #333333;
                font-weight: bold;
                line-height: 25px;
            }

            .order-no-box {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .order-no {
                    font-size: 15px;
                    font-weight: 400;
                    color: #666666;
                }

                .pay-price {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333333;

                    .red {
                        color: #BE0505;
                    }
                }

            }

            .type-box {
                width: 1130px;
                height: 190px;
                border: 1px solid #DDDDDD;
                margin-top: 20px;

                .header {
                    height: 50px;
                    line-height: 50px;
                    background: #F5F5F5;
                    padding-left: 20px;
                    color: #666666;
                    font-size: 15px;
                }

                .pay-box {
                    height: 140px;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;

                    .pay {
                        margin-right: 60px;
                        display: flex;
                        align-items: center;
                    }
                }
            }

            .submit-box {
                text-align: right;

                .submit {
                    width: 144px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: #0F114A;
                    font-size: 15px;
                    color: #FFFFFF;
                    margin-top: 20px;
                    display: inline-block;
                    cursor: pointer;
                }

                .pay-time {
                    margin-top: 10px;
                    height: 20px;
                    font-size: 14px;
                    color: #666666;
                }
            }

        }
    }

    .credit {
        font-size: 15px;
        color: #0F114A;
        margin-left: 10px;
    }

    .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal {
            top: 0;
        }
    }
	.coupon-box{
		background: #FFFFFF;
		// padding: 20px;
		margin-top: 20px;
		border: 1px solid #DDDDDD;
		.header {
			height: 50px;
			line-height: 50px;
			background: #F5F5F5;
			padding-left: 20px;
			color: #666666;
			font-size: 15px;
		}
		.coupon-list{
			padding: 20px;
			.items {
				float: left;
				margin-right: 20px;
				margin-bottom: 30px;
				display: flex;
				align-items: center;
				color: #FFFFFF;
				.coupon-bg{
					width: 86px;
					height: 100px;
					position: relative;
					margin-left: 30px;
					.img{
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						z-index: 1;
					}
					.money{
						position: absolute;
						top: 20px;
						left: 0;
						text-align: center;
						z-index: 2;
						width: 100%;
						font-size: 20px;
						font-family: PingFang SC;
						font-weight: 600;
					}
					.desc{
						position: absolute;
						top: 53px;
						left: 0;
						text-align: center;
						z-index: 2;
						width: 100%;
						font-size: 15px;
						font-family: PingFang SC;
						font-weight: 400;
					}
				}
			}
		}

	}
</style>
